export default [
  { label: 'Incoming', value: 'new' },
  { label: 'Application Sent', value: 'application-sent' },
  { label: 'Application Received', value: 'application-received' },
  { label: 'Waitlisted', value: 'waitlisted' },
  { label: 'Accepted', value: 'accepted' },
  { label: 'Archived', value: 'archived' },
  // { label: 'All', value: 'all' },
];
